import { FormEventHandler, forwardRef, useEffect, useRef, useState } from 'react'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import Completed from './components/Completed'

interface TimerInterface {
  bottomContent?: string
  hideCostLPH?: number
  marginOfError?: number
  costPerKL?: number
  billingPeriodDays?: number
  periodMinSeconds?: number
  saveWaterUrl?: string
}
const duration = 900

const SeekALeak = ({
  bottomContent,
  hideCostLPH = 1,
  marginOfError = 5,
  costPerKL = 20,
  billingPeriodDays = 60,
  periodMinSeconds = 60,
  saveWaterUrl = '#'
}: TimerInterface) => {
  const btnRef = useRef<HTMLButtonElement>(null)
  const [isPlaying, setIsPlaying] = useState<boolean>(false)
  const [initialRemainingTime, setInitialRemainingTime] = useState<
    number | undefined
  >(() => {
    const start = window.localStorage.getItem('start-time')
    if (start) {
      return duration - (Date.now() - Number(start)) / 1000
    }
  })
  const [pastMinPeriod, setPastMinPeriod] = useState<boolean>(true)
  const [valid, setValid] = useState<boolean>(false)
  const [meterReading, setMeterReading] = useState<[string, string, string]>(["", "", ""])
  const [step, setStep] = useState<'start' | 'end' | 'complete'>('start')

  const handleReset = () => {
    setStep('start')
    setIsPlaying(false)
    setPastMinPeriod(true)
    setValid(false)
    setInitialRemainingTime(undefined)
    setMeterReading(["", "", ""])
    window.localStorage.removeItem('start-reading')
    window.localStorage.removeItem('end-reading')
    window.localStorage.removeItem('start-time')
    window.localStorage.removeItem('end-time')
  }

  useEffect(() => {
    const start = window.localStorage.getItem('start-time')
    if (start) {
      const endReading = window.localStorage.getItem('end-reading')
      if (start && !endReading) {
        const x = duration - (Date.now() - Number(start)) / 1000
        if (x > 0) {
          setIsPlaying(true)
          setStep('end')
        }
        if (x < 0 && Math.abs(x) > 14400) {
          handleReset()
        }
      }
      if (endReading) {
        setStep('complete')
      }
    }
  }, [])

  useEffect(() => {

    let mr = meterReading.join("")
    console.log(mr)
    if (meterReadingIsValid(mr)) {
      setValid(true)
      btnRef.current?.focus()
    } else {
      setValid(false)
    }
  }, [meterReading])


  const handleSubmit: FormEventHandler<HTMLFormElement> | undefined = (
    event
  ) => {
    event.preventDefault()
    if (step === ('end' || 'start') && !valid) {
      return
    }
    let mr = meterReading.join("")
    if (meterReadingIsValid(mr)) {
      window.localStorage.setItem(`${step}-reading`, mr)
      window.localStorage.setItem(`${step}-time`, Date.now().toString())
      setStep((currentStep) => {
        switch (currentStep) {
          case 'start':
            setMeterReading(["", "", ""])
            setValid(false)
            setIsPlaying(true)
            return 'end'
          case 'end':
            return 'complete'
          default:
            return 'start'
        }
      })
    }
  }

  if (step === 'complete') {
    return (
      <Completed
        handleReset={handleReset}
        bottomContent={bottomContent}
        hideCostLPH={hideCostLPH}
        marginOfError={marginOfError}
        costPerKL={costPerKL}
        billingPeriodDays={billingPeriodDays}
        saveWaterUrl={saveWaterUrl}
      />
    )
  }

  return (
    <form
      className="wc-seek-a-leak block bg-grey-50 my-12 mx-0 py-8 px-2 md:px-8"
      onSubmit={handleSubmit}
    >
      <h6 className="wc-instructions">
        {step === 'start'
          ? 'Enter the red numbers shown on the top of your meter.'
          : 'Wait for 15 minutes, then enter the red numbers shown on the top of your meter.'}
      </h6>
      <div className="flex flex-wrap items-center justify-center gap-8">
        <MeterInput meterReading={meterReading} setMeterReading={setMeterReading} />
        <div className='flex-none'>
          <CountdownCircleTimer
            duration={duration}
            colors={['#52C7E6', '#C5361B']}
            colorsTime={[duration - 10, 0]}
            initialRemainingTime={initialRemainingTime}
            isPlaying={isPlaying}
            updateInterval={1}
            trailColor="#D5D5D5"
            strokeLinecap="square"
            strokeWidth={8}
            size={122}
          >
            {({ remainingTime, elapsedTime }) => {
              if (elapsedTime > periodMinSeconds) {
                setPastMinPeriod(true)
              }
              if (remainingTime <= 0) {
                // handleReset()
                return (
                  <div className='h6 p-0 m-0 leading-none text-validation-red font-semibold'>00:00</div>
                )
              }
              const min = Math.floor(remainingTime / 60)
              const sec = remainingTime % 60
              const minutes = `${min < 10 ? '0' : ''}${min}`
              const seconds = `${sec < 10 ? '0' : ''}${sec}`
              return (
                <p className="h6 p-0 m-0 leading-none font-semibold">
                  {minutes}:{seconds}
                </p>
              )
            }}
          </CountdownCircleTimer>
        </div>

        <button
          ref={btnRef}
          className="btn-primary btn-mobile my-8"
          type="submit"
          disabled={!valid || (!pastMinPeriod && step === 'end')}
        >
          {`${step === 'start' ? 'Start' : 'Stop'}`} Timer
        </button>
      </div>

    </form>
  )
}

function meterReadingIsValid(meterReading: string) {
  const re = new RegExp('\\d\\d\\d')
  return re.test(meterReading)
}
const isNumber = new RegExp('\\d')
function MeterInput({ meterReading, setMeterReading }) {
  const ref1 = useRef<HTMLInputElement>(null)
  const ref2 = useRef<HTMLInputElement>(null)
  const ref3 = useRef<HTMLInputElement>(null)
  function onMeterReadingChange(id: 0 | 1 | 2) {
    return (e) => {
      let newRead: [string, string, string] = [...(meterReading as [string, string, string])]
      let isValid = isNumber.test(e.target?.value) || !e.target?.value
      if (isValid) {
        newRead[id] = e.target.value
      }

      setMeterReading(newRead)
      if (id === 0 && e.target.value) {
        ref2?.current?.focus()
      }
      if (id === 1 && e.target.value) {
        ref3?.current?.focus()
      }
    }
  }
  function handleDelete(id: 0 | 1 | 2) {
    return (e) => {
      if (!meterReading[id] && (e.key === "Delete" || e.key === "Backspace")) {
        if (id === 1) {
          ref1?.current?.focus()
        }
        if (id === 2) {
          ref2?.current?.focus()
        }
      }
    }

  }

  return (
    <div className='@container w-full min-w-[295px] max-w-2xl'>
      <div className="flex gap-2 @xs:gap-4 h-16 @xs:h-24">
        <div><IgnoreValue /></div>
        <div><IgnoreValue /></div>
        <div><IgnoreValue /></div>
        <div><IgnoreValue /></div>
        <div><IgnoreValue /></div>
        <div><ReadValue ref={ref1} onDelete={handleDelete(0)} onMeterReadingChange={onMeterReadingChange(0)} value={meterReading[0]} /></div>
        <div><ReadValue ref={ref2} onDelete={handleDelete(1)} onMeterReadingChange={onMeterReadingChange(1)} value={meterReading[1]} /></div>
        <div><ReadValue ref={ref3} onDelete={handleDelete(2)} onMeterReadingChange={onMeterReadingChange(2)} value={meterReading[2]} /></div>
      </div>
    </div>
  )
}
function IgnoreValue() {
  return (
    <input className="h-full w-full max-w-[45px] rounded-md border-4 border-grey-600 text-grey-600 bg-grey-200  text-center text-h3" disabled value="X" />
  )
}
const ReadValue = forwardRef(function ReadValue({ onMeterReadingChange, onDelete, value }: { onMeterReadingChange: (e) => void; onDelete: (e) => void; value: string }, ref: React.ForwardedRef<HTMLInputElement>) {
  return (
    <input
      ref={ref}
      size={1}
      name="reading"
      pattern="\d*"
      type="text"
      aria-label="red number on your meter"
      onKeyDown={onDelete}
      onChange={onMeterReadingChange}
      value={value}
      maxLength={1}
      className="h-full w-full max-w-[45px] rounded-md border-4 border-validation-red text-validation-red bg-white text-center text-h3" />
  )
})


export default SeekALeak
